<template>
    <div class="text-sm-left">
        <v-dialog
                v-model="dialog"
                width="1500"
                persistent
        >
            <template v-slot:activator="{ on }">
                <v-btn
                        color="primary"
                        dark
                        v-on="on"
                        @click="cargarData"
                >
                    Insertar/eliminar diagnósticos
                </v-btn>
            </template>
            
            <v-dialog v-model="dialogBusqueda" max-width="500px"
              transition="dialog-bottom-transition"
              scrollable persistent>              
              <v-card>
                <v-toolbar card dark color="nav_background_color">
                  <v-btn icon dark @click.native="dialogBusqueda = false">
                    <v-icon>close</v-icon>
                  </v-btn>                  
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                  Buscar diagnóstico
                </v-card-title>
                <v-card-text>                                  
                  <v-text-field
                          v-model="search"
                          label="Buscar en diagnósticos"                                                      
                  ></v-text-field>  
                </v-card-text>                                    
                <v-btn color="primary" dark @click="buscarDiagnostico">Buscar</v-btn>
                <v-spacer></v-spacer>
                <v-data-table
                  :headers="headers"
                  :items="diagnosticosBusqueda"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.name }}</td>                    
                    <td>                      
                      <v-btn 
                        dark 
                        @click="seleccionarDiagnostico(props.item)" 
                        slot="activator"
                        color="primary">
                        <span>Seleccionar</span>
                      </v-btn>                                                          
                    </td>
                  </template>
                </v-data-table>               
              </v-card>
            </v-dialog>
            
            <v-card>
                <v-card-title class="grey lighten-3">
                    Diagnósticos
                    <v-btn 
                      dark 
                      @click="abrirBuscador" 
                      slot="activator"
                      color="primary">
                      <span>Buscar diagnóstico</span>
                    </v-btn>  
                </v-card-title>                
                <v-layout
                        justify-space-between
                        pa-3
                >
                    <v-flex xs5>
                        <v-treeview
                                :active.sync="active"
                                :items="items"
                                :load-children="getDiagnosticosChildren"
                                :open.sync="open"
                                activatable
                                active-class="primary--text"
                                class="grey lighten-5"
                                open-on-click
                                transition
                                :filter="filter"                                
                        >
                            <template v-slot:prepend="{ item, active }">
                                <v-icon
                                        v-if="!item.children"
                                        :color="active ? 'primary' : ''"
                                >
                                    mdi-account
                                </v-icon>
                            </template>
                        </v-treeview>
                    </v-flex>

                    <v-divider vertical></v-divider>

                    <v-flex
                            xs12
                            md6
                    >
                        <v-card-text>
                            <div
                                    v-if="this.selections.length === 0"
                                    key="title"
                                    class="title font-weight-light grey--text pa-3 text-xs-center"
                            >
                                Seleccione diagnósticos
                            </div>

                            <v-list>


                                <v-list-tile
                                        v-for="item in this.selections"
                                        :key="item.id"
                                        dense
                                >

                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-btn icon ripple @click="deleteItem(item)">
                                            <v-icon color="grey lighten-1">delete</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>


                            </v-list>

                        </v-card-text>
                    </v-flex>
                </v-layout>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                            flat
                            @click="dialog = false"
                            color="accent"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                            flat
                            @click="clearSelections"
                    >
                        Seleccionar de nuevo
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                            class="white--text"
                            color="primary"
                            depressed
                            @click="agregarSeleccion"
                    >Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>            
        </v-dialog>
    </div>
</template>

<script>
    const avatars = [
        '?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban',
        '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun',
        '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong',
        '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair',
        '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly'
    ]

    const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

    export default {
        props: {
            listaDiagnosticosPadre: {
                required: true,
                type: Array
            }
        },
        data: () => ({
            active: [],
            avatar: null,
            open: [],
            diagnosticos: [],
            dialog: false,
            diagnosticosAux: [],
            selections: [],
            search: null,
            listaDiagnosticosPadreAux: [],
            diagnosticosBusqueda: [],
            headers: [
              { text: 'Nombre', value: 'name' },
              { text: 'Acción', value: 'accion' }              
            ],
            dialogBusqueda: false
        }),

        computed: {
            filter() {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined
            },
            items() {
                return this.diagnosticos;
            }
        },

        watch: {
            active(val) {
                if (this.selections.find(diagnostico => diagnostico.id === val[0]) != null) {
                    return;
                }
                var newItem = this.getDiagnostico(val[0]);
                if (newItem !== undefined) {
                    this.selections.push(newItem);
                }
            }
        },

        methods: {
            getDiagnosticosParents() {
                this.$store.dispatch('getCie10Groups').then(response => {
                    for (let i = 0; i < response.data.length; i++) {
                        this.diagnosticosAux.push({
                            id: response.data[i].id,
                            name: response.data[i].descripcion + " " + response.data[i].clave,
                            code: response.data[i].clave,
                            level: 1,
                            children: []
                        });
                        this.diagnosticos.push({
                            id: response.data[i].id,
                            name: response.data[i].descripcion + " " + response.data[i].clave,
                            code: response.data[i].clave,
                            level: 1,
                            children: []
                        });
                    }
                }, error => {
                    this.$store.state.dialogError = true;
                })
            },
            async getDiagnosticosChildren(parent) {
                if (typeof (parent) === 'object') {
                    if (parent.level == 1) {
                        await this.$store.dispatch('getCie10SubGroups', parent.id).then(response => {
                            for (let i = 0; i < response.data.length; i++) {
                                var diagnostico = {};
                                diagnostico.id = response.data[i].id;
                                diagnostico.name = response.data[i].descripcion + " " + response.data[i].clave,
                                    diagnostico.code = response.data[i].clave,
                                    diagnostico.level = 2,
                                    diagnostico.children = [];
                                this.diagnosticosAux.push(diagnostico);
                                parent.children.push(diagnostico);
                            }
                        }, error => {
                            this.$store.state.dialogError = true;
                        })
                    } else if (parent.level == 2) {
                        await this.$store.dispatch('getCie10SubCategoryGroups', parent.id).then(response => {
                            for (let i = 0; i < response.data.length; i++) {
                                var diagnostico = {};
                                    diagnostico.id = response.data[i].id;
                                    diagnostico.name = response.data[i].descripcion + " " + response.data[i].clave,
                                    diagnostico.code = response.data[i].clave,
                                    diagnostico.level = 3,
                                    this.diagnosticosAux.push(diagnostico);
                                    parent.children.push(diagnostico);
                            }
                        }, error => {
                            this.$store.state.dialogError = true;
                        })
                    }
                }
            },
            getDiagnostico(id) {
                return this.diagnosticosAux.find(diagnostico => diagnostico.id === id);
            },
            clearSelections() {
                this.selections = [];
                this.open = [];
                this.active = [];
            },
            deleteItem(item) {
                this.active = [];
                var index = this.selections.indexOf(item);
                this.selections.splice(index, 1);
            },
            agregarSeleccion() {
                this.$emit('clicked', this.selections);
                this.dialog = false;
            },
            getListaDiagnosticosPadre() {
                this.listaDiagnosticosPadreAux = this.listaDiagnosticosPadre;
                return this.listaDiagnosticosPadreAux;
            },
            cargarData() {
                this.active = [];
                this.open = [];
                this.selections = this.getListaDiagnosticosPadre();
            },
            buscarDiagnostico() {
              console.log(this.search)
              this.$store.dispatch('findCie10SubCategoryGroupsByDescripcion', this.search)
                .then(response => {
                  for (let i = 0; i < response.data.length; i++) {
                      var diagnostico = {};
                      diagnostico.id = response.data[i].id;
                      diagnostico.name = response.data[i].descripcion + " " + response.data[i].clave;
                      diagnostico.code = response.data[i].clave;
                      diagnostico.level = 3;
                      console.log(diagnostico)
                      this.diagnosticosBusqueda.push(diagnostico);                          
                  }
              }, error => {
                  this.$store.state.dialogError = true;
              })
            },
            seleccionarDiagnostico(item) {
              this.selections.push(item);
              this.dialogBusqueda = false;
            },
            abrirBuscador() {
              this.dialogBusqueda = true;
              this.diagnosticosBusqueda = [];
              this.search = "";
            }
        },
        created: function () {
            this.getDiagnosticosParents();
        }
    }
</script>
<style scoped>
    .v-treeview-node__label {
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/diagnosticos/Diagnosticos.vue